import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Logo from './Logo';

export default function Footer() {
  const { t } = useTranslation();
  const year = new Date().getFullYear();
  return (
    <footer className="border-t border-border bg-surface">
      <div className="mx-auto max-w-6xl px-4 py-10">
        <div className="flex flex-col gap-8 sm:flex-row sm:items-center sm:justify-between">
          <div>
            <Logo className="h-8 w-auto" />
            <p className="mt-3 text-sm text-text-muted">{t('footer.tagline')}</p>
          </div>
          <div>
            <ul className="flex flex-col gap-2 text-sm sm:flex-row sm:flex-wrap sm:items-center sm:gap-x-6">
              <li>
                <Link to="/pricing" className="text-text-muted transition hover:text-text">
                  {t('nav.pricing')}
                </Link>
              </li>
              <li>
                <Link to="/privacy" className="text-text-muted transition hover:text-text">
                  {t('footer.privacy')}
                </Link>
              </li>
              <li>
                <Link to="/terms" className="text-text-muted transition hover:text-text">
                  {t('footer.terms')}
                </Link>
              </li>
              <li>
                <a
                  href="mailto:admin@jawabai.cloud"
                  className="text-text-muted transition hover:text-text"
                >
                  admin@jawabai.cloud
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="mt-8 border-t border-border pt-6 text-center text-xs text-text-faint">
          © {year} jawabai. {t('footer.rights')}.
        </div>
      </div>
    </footer>
  );
}
